// extracted by mini-css-extract-plugin
export var askAiIcon = "_r5-9";
export var container = "_r5-0";
export var groupSeparator = "_r5-a";
export var highlight = "_r5-4";
export var resultIcon = "_r5-5";
export var resultItem = "_r5-7";
export var resultSubtitle = "_r5-3";
export var resultTitle = "_r5-2";
export var resultsList = "_r5-1";
export var searchGroup = "_r5-6";
export var selected = "_r5-8";